export default __webpack_public_path__ + "static/media/338.a1f9cc97.png";